module.exports = __webpack_public_path__ + "static/media/DEAL MAP-LOGO.d4a54122.png";